import { Button } from '@mui/material';
import { BULK_UPLOAD_HEADERS, BULK_UPLOAD_SAMPLE_DATA } from '../constants';

const BulkWizardTemplate = () => {
  const headers = BULK_UPLOAD_HEADERS;
  const sampleData = BULK_UPLOAD_SAMPLE_DATA;

  const headerString = headers.map((h) => `"${h}"`).join(',');

  const dataString = sampleData
    .map((row) => {
      return row.map((cell) => `"${cell}"`).join(',');
    })
    .join('\n');

  const csvData = `${headerString}\n${dataString}`;

  return (
    <Button variant="contained" color="primary" href={`data:text/csv;charset=utf-8,${encodeURIComponent(csvData)}`} download="bulk-wizard-template.csv" size="small">
      Download Template
    </Button>
  );
};

export default BulkWizardTemplate;
